var render = function render(){
  var _vm$location, _vm$currentTab;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.isLoading ? _c('div', [_vm.isNewLocation ? _c('page-title', {
    attrs: {
      "title": "Nieuwe locatie toevoegen",
      "icon": "pe-7s-global"
    }
  }) : _c('page-title', {
    attrs: {
      "title": `${_vm.$t('omt.gui.location-management.label.title')}: ${_vm.$t(_vm.location.location_type.display_name)} &rarr; ${_vm.location.display_name}`,
      "icon": "pe-7s-global"
    }
  }), _c('div', {
    staticClass: "row mb-2",
    attrs: {
      "data-location-id": (_vm$location = _vm.location) === null || _vm$location === void 0 ? void 0 : _vm$location.id
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('ul', {
    staticClass: "nav nav-tabs mb-4"
  }, _vm._l(_vm.visibleTabs, function (tab, index) {
    return _c('li', {
      key: index,
      staticClass: "nav-item"
    }, [_c('router-link', {
      staticClass: "nav-link",
      class: {
        active: _vm.isMatchedRoute(tab.matchRouteNames)
      },
      attrs: {
        "tag": "a",
        "to": tab.route
      }
    }, [_c('i', [_vm._v(_vm._s(tab.name))])])], 1);
  }), 0), !((_vm$currentTab = _vm.currentTab) !== null && _vm$currentTab !== void 0 && _vm$currentTab.visible()) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.location-management.errors.no-permission-for-tab')) + " ")]) : _c('router-view', {
    attrs: {
      "location": _vm.location,
      "location-types": _vm.locationTypes,
      "email-types": _vm.emailTypes,
      "phone-types": _vm.phoneTypes,
      "address-types": _vm.addressTypes,
      "service-types": _vm.serviceTypes
    },
    on: {
      "locationUpdated": _vm.getLocation
    }
  })], 1)])], 1) : _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }